import { create } from 'zustand'
import { applyStep } from './stepReducer'

export const DEFAULT_VISUAL_STATE = {
  elements:    [],
  nodes:       [],
  edges:       [],
  nodePointers: {},
  pointers:    {},
  variables:   {},
  operation:   '',
  explanation: '',
  callStack:   [],
  gridRows:    0,
  gridCols:    0,
  gridCells:   [],
  dpRows:      0,
  dpCols:      0,
  dpCells:     [],
  dpRowLabels: [],
  dpColLabels: [],
  btNodes:     [],
  btEdges:     [],
}

export const useDSAStore = create((set, get) => ({
  // Selection
  selectedCategory:  'Arrays',
  selectedAlgorithm: 'two-sum',

  // Playback
  isPlaying:   false,
  speed:       1,
  currentStep: 0,
  steps:       [],
  complexity:  { time: 'O(n)', space: 'O(1)' },

  // Camera hint
  cameraTarget: [0, 0, 0],

  // Visual state
  ...DEFAULT_VISUAL_STATE,

  setAlgorithm: (category, id) =>
    set({ selectedCategory: category, selectedAlgorithm: id, isPlaying: false, currentStep: 0, steps: [], ...DEFAULT_VISUAL_STATE }),

  setPlaying:      (v) => set({ isPlaying: v }),
  setSpeed:        (v) => set({ speed: v }),
  setCameraTarget: (t) => set({ cameraTarget: t }),

  // initialState lets algorithm loaders pre-seed specific fields
  // (e.g. pass elements: [...] for array algorithms, or leave empty for graph algorithms
  //  whose init-graph step sets everything up).
  loadSteps: (steps, initialState = {}, complexity) =>
    set({
      steps,
      currentStep: 0,
      isPlaying:   false,
      complexity:  complexity || { time: 'O(n)', space: 'O(1)' },
      ...DEFAULT_VISUAL_STATE,
      ...initialState,
    }),

  applyStep: (step) =>
    set((state) => {
      const next = applyStep(state, step)
      return { ...next, currentStep: state.currentStep }
    }),

  stepForward: () => {
    const state = get()
    if (state.currentStep >= state.steps.length) {
      set({ isPlaying: false })
      return false
    }
    const step = state.steps[state.currentStep]
    get().applyStep(step)
    set({ currentStep: state.currentStep + 1 })
    return true
  },

  reset: () =>
    set((state) => {
      // Re-apply step 0 (the init event) to restore original values,
      // then advance to step 1 so the scene matches the post-init frame.
      const initStep = state.steps[0]
      if (!initStep) return { isPlaying: false, currentStep: 0 }
      const next = applyStep({ ...state, ...DEFAULT_VISUAL_STATE }, initStep)
      return { ...next, isPlaying: false, currentStep: 1 }
    }),
}))
